import { render, staticRenderFns } from "./Pergunta.vue?vue&type=template&id=4afeebb9&scoped=true&"
import script from "./Pergunta.vue?vue&type=script&lang=js&"
export * from "./Pergunta.vue?vue&type=script&lang=js&"
import style0 from "./Pergunta.vue?vue&type=style&index=0&id=4afeebb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afeebb9",
  null
  
)

export default component.exports